import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import './FooterButtons.css'
import WT from "@sscale/wtsdk";

function FooterButtons(props) {
  const { leaveCall, openChatWindow } = props
  let { isCelebrity, roomLink } = useSelector(state => state.participant);
  const { participants } = useSelector( state => state.session);
  const [micState, setMicState ] = useState(true)
  const [videoState, setVideoState ] = useState(true)
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            setIsMobile(true)
        }

    }, [window.clientWidth]);


    function toggleCamera() {
      participants.map(participant => {
          if (participant.local) {
              if (WT.Participant.isVideoEnabled()) {
                  WT.Participant.disableVideo()
                  setVideoState(false)
              } else {
                  WT.Participant.enableVideo();
                  setVideoState(true)
              }
          }
      })
    }

    function toggleMic() {
        participants.map(participant => {
            if (participant.local) {
                // eslint-disable-next-line no-undef
                if (WT.Participant.isAudioEnabled()) {
                    WT.Participant.disableAudio();
                    setMicState(false)
                } else {
                    WT.Participant.enableAudio();
                    setMicState(true)
                }
            }
        })

    }

  return (
    <div className={`sfb-buttons-container ${isCelebrity ? 'celebrity' : ''}`}>

        <div className='sfb-footer-buttons'>
            <button
                className='sfb-button'
                onClick={() => {
                    toggleMic()
                }}
            >
                { micState ? <div className='mic-control-button'></div>:<div className='mic-control-button disable'></div> }
                <div className='s-sd-arrow-right' />
            </button>
        </div>
        <div className='sfb-footer-buttons'>
            <button
                className='sfb-button'
                onClick={() => {
                    toggleCamera()
                }
                }
            >
                {videoState ? <div className='video-control-button'></div>: <div className='video-control-button disable'></div>}
                <div className='s-sd-arrow-right' />
            </button>
        </div>
      <div className='sfb-footer-buttons'>
        <button
          className='sfb-button'
          onClick={leaveCall}
        >
          <div className='leave-call-button'></div>

          <div className='s-sd-arrow-right' />
        </button>
      </div>

        {isMobile &&
        <div className='sfb-footer-buttons'>
            <button
                className='sfb-button'
                onClick={() => {
                    openChatWindow()
                }
                }
            >
                <div className='open-chat-button'></div>

                <div className='s-sd-arrow-right' />
            </button>
        </div>
        }


    </div>
  )
}

export default FooterButtons
